import SurveyQuizQuestion from "./SurveyQuizQuestion";
import SurveyQuizNav from "./SurveyQuizNav";
import "./SurveyQuiz.css";

const SurveyQuiz = props => {
  const isFirstQuestion =  props.currentSurveyQuestionI == 0;
  const isDisqualified = props.currentSurveyQuestionI == 1;
  const showPrevious = !isFirstQuestion;

  return (
    <div className="surveyQuiz">
        {
           props.surveyQuestions.map((question, i)=> 
            <div key={`surveyQuizQuestionContainerKey${i}`} className="overflow-hidden">
              <SurveyQuizQuestion 
                key={`surveyQuizQuestionKey${i}`}
                {...props}
                question={question}
                questionI={i}
                desktop={props.desktop}
              />
            </div>
          )
         }
         <SurveyQuizNav 
          showPrevious={showPrevious} 
          showContinue={(!isDisqualified && !isFirstQuestion) || (isFirstQuestion && props.currentValueFullfilled())}
          previousQuestion={props.previousQuestion}
          currentValueFullfilled={props.currentValueFullfilled}
          currentQuestionI={props.currentSurveyQuestionI}
          nextQuestion={props.nextQuestion} 
          complete={props.currentSurveyQuestion.type == "QuizSurveyComplete"}
          closeSurveyComplete={props.closeSurveyComplete}
         />
    </div>
  );
};

export default SurveyQuiz;
